import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) `
  --bgColor: transparent;
  --fgColor: ${brand.primary.black};
  --buttonSize: ${fluid(24, 32)};
  --gutter: ${fluid(8, 64, Device.MobileLarge)};
  --modalWidth: 100vw;

  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: var(--fgColor);
  height: 100%;
  width: 100%;
  z-index: ${Layers.Modal};
  max-width: var(--modalWidth, 100%);
  padding-top: calc(var(--buttonSize) + var(--gutter));

  &[data-open='false'] {
    display: none;
  }
`;
const Inner = styled(m.div) `
  position: relative;
  align-self: center;
  justify-self: center;
  max-width: calc(100% - var(--gutter) * 2);
  max-height: calc(100% - var(--gutter) * 2 - var(--buttonSize));
  width: 100%;
  aspect-ratio: 16 / 9;

  > video,
  > img {
    max-height: 100%;
    max-width: 100%;
  }

  @media ${from(Device.TabletLarge)} {
    width: auto;
    height: 100%;
  }
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
